// extracted by mini-css-extract-plugin
export default {"container":"aQP_sen5GLYiWq4a8BnJ","descriptionCard":"zew4ewc1DoGmC_LLEAJ1","cardsGrid":"CCNAVchMLVcYomgbg6XK"};